import React, { useState, useCallback, useEffect } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import "./prototypeFabrication.css"
import logoPrototypeFabrication from "../../imagens/logos/logoPrototypeFabrication.png"



function PrototypeFabrication({ listPrototypeFabrication }) {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)


    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const prevSlide = useCallback(() => {
        slideNumber === 0
            ? setSlideNumber(listPrototypeFabrication.length - 1)
            : setSlideNumber(slideNumber - 1)
    }, [slideNumber, listPrototypeFabrication.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listPrototypeFabrication.length
            ? setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)
    }, [slideNumber, listPrototypeFabrication.length])

    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);

    return (
        <div >
            {
                openModal &&
                <div className="PrototypeFabricationSliderWrap">
                    <FontAwesomeIcon icon={faCircleXmark} className="PrototypeFabricationBtnClose" onClick={() => handleCloseModal()} />
                    <FontAwesomeIcon icon={faCircleChevronLeft} className="PrototypeFabricationBtnPrev" onClick={() => nextSlide()} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className="PrototypeFabricationBtnNext" onClick={() => prevSlide()} />
                    <img className="PrototypeFabricationFullScreen" src={listPrototypeFabrication[slideNumber].img} alt="" />
                </div>
            }
            <div className='img-custom-size img-fluid ms-2'>
                <img src={logoPrototypeFabrication} alt='logoCapabilities'></img>
            </div>
            <div className="PrototypeFabricationGalleryWrap">
                {
                    listPrototypeFabrication && listPrototypeFabrication.map((image, index) => {
                        return (
                            <div
                                className="PrototypeFabricationSingle"
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >
                                <img src={image.img} alt="PrototypeFabrication" />

                            </div>
                        )
                    })
                }
            </div>
            <div className="text-center text-nowrap my-4">
                <Link to="/Capabilities/Engineer">
                    <button className="buttonCapabilities">Back to Engineer Capabilities</button>
                </Link>
            </div>
        </div>
    )
}

export default PrototypeFabrication